import React from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash.isequal';

import {
    requestHarvestEventsLoad,
    harvestEventsLoadCanceled
} from 'services/harvestEvents/actions';
import { AppState } from 'services/types';
// @ts-ignore
import { selectHarvestEventsLoadParams } from 'services/harvestEvents/params';
import { createStructuredSelector } from 'reselect';

interface ConnectedProps {
    parameters: Record<string, any>;
}

interface DispatchProps {
    loadHarvestEvents: Function;
    cancelLoadHarvestEvents: Function;
}

type Props = ConnectedProps & DispatchProps;

export class HarvestEventsRequest extends React.Component<Props> {
    componentDidMount(): void {
        const { loadHarvestEvents } = this.props;

        loadHarvestEvents();
    }

    componentDidUpdate(prevProps: Props): void {
        const { parameters, loadHarvestEvents } = this.props;

        if (!isEqual(prevProps.parameters, parameters)) {
            loadHarvestEvents();
        }
    }

    componentWillUnmount(): void {
        const { cancelLoadHarvestEvents } = this.props;

        cancelLoadHarvestEvents();
    }

    render(): null {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    parameters: selectHarvestEventsLoadParams
});

export default connect(
    mapStateToProps,
    {
        loadHarvestEvents: requestHarvestEventsLoad,
        cancelLoadHarvestEvents: harvestEventsLoadCanceled
    }
)(HarvestEventsRequest);
